const AboutData = {
    about_head_tag: "About Me",
    about_head_title: "Know Me More",

    about_content_name: "Niladri Mondal",
    about_content_desc:
        "I'm a creative & passionate front end developer with a keen eye in design. I enjoy developing simple, clean, attractive and slick websites that provide real value & interests to the end user. Delivering work within time and budget which meets client’s requirements is my moto.",
    about_content_exp: "2",

    about_footer_name: "Niladri Mondal",
    about_footer_email: "nm2346@ee.jgec.ac.in",
    about_footer_dob: "4th October, 2000",
    about_footer_place: "JGEC, WB, IN",
};

export default AboutData;
